import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {Observable} from 'rxjs/internal/Observable';
import {TechnicalDeviceElement} from '@models/technical-device-element';
import {map} from 'rxjs/operators';

@Injectable()
export class TechnicalDeviceElementsPagesService extends PagingApiService<TechnicalDeviceNamespace.Element> {
    public deviceId: number;

    public listItems$: Observable<TechnicalDeviceElement[]> = this.items$.pipe(
        map(items => items.map(item => new TechnicalDeviceElement(item)))
    );

    get pagingUrl(): string {
        return `technical-device/${this.deviceId}/elements-pages`;
    }

    defaultItemsPerPage = 10;
}
